export enum ReviewCycleLaunchType {
  immediate = 'immediate',
  scheduled = 'scheduled',
}

export enum ReviewCycleStateType {
  draft = 'draft',
  launched = 'launched',
  closed = 'closed',
  canceled = 'canceled',
  scheduled = 'scheduled',
}

export enum HumanReadableReviewCycleStateType {
  draft = 'Draft',
  launched = 'In Progress',
  closed = 'Closed',
  canceled = 'Canceled',
  scheduled = 'Scheduled',
}

export enum RuleType {
  employeeSet = 'employee_set',
  minimumTenure = 'minimum_tenure',
  includeEmployees = 'include_employees',
  includeDepartments = 'include_departments',
  excludeEmployees = 'exclude_employees',
}

export enum EmployeeSetValue {
  allWithManagers = 'all_with_managers',
  subsetWithManagers = 'subset_with_managers',
}

export class EmployeeSetRule {
  constructor(value: EmployeeSetValue) {
    this.ruleType = RuleType.employeeSet;
    this.set = value;
  }

  ruleType: RuleType.employeeSet;
  set: EmployeeSetValue;
}

type TenureRuleValue = 90 | 60 | 30 | 0;

export class MinimumTenureRule {
  constructor(value: TenureRuleValue) {
    this.ruleType = RuleType.minimumTenure;
    this.minimumTenure = value;
  }

  ruleType: RuleType.minimumTenure;
  minimumTenure: TenureRuleValue;
}

export class IncludeEmployeesRule {
  constructor(value: string[]) {
    this.ruleType = RuleType.includeEmployees;
    this.includeEmployees = value;
  }

  ruleType: RuleType.includeEmployees;
  includeEmployees: string[];
}

export class IncludeDepartmentsRule {
  constructor(value: string[]) {
    this.ruleType = RuleType.includeDepartments;
    this.includeDepartments = value;
  }

  ruleType: RuleType.includeDepartments;
  includeDepartments: string[];
}

export class ExcludeEmployeesRule {
  constructor(value: string[]) {
    this.ruleType = RuleType.excludeEmployees;
    this.excludeEmployees = value;
  }

  ruleType: RuleType.excludeEmployees;
  excludeEmployees: string[];
}

// Combine the specific rule interfaces into a union type
export type Rule =
  | EmployeeSetRule
  | IncludeEmployeesRule
  | IncludeDepartmentsRule
  | MinimumTenureRule
  | ExcludeEmployeesRule;

export interface AssignmentRuleType {
  rules: Rule[];
}

export type ReviewCycleType = {
  slug: string;
  name: string;
  assignmentRule: AssignmentRuleType;
  description: string;
  reviewTemplateSlug: string;
  state: ReviewCycleStateType;
  selfAndPeerReviewsDueBy: Date | string;
  managerReviewsDueBy: Date | string;
  reviewsSharedBy: Date | string;
  launchedAt: Date | string;
  closedAt: Date | string;
  createdAt: string;
  launchType: ReviewCycleLaunchType;
  metrics: {
    total: number;
    selfReviewsCompleted: number;
    managerReviewsCompleted: number;
    reviewsShared: number;
    reviewsOpened: number;
  };
  scheduledAt: Date | string;
};
